<style lang="scss" scoped>
@screen mobile {
  .section {
    &__body {
      @apply p-4;
    }
  }
}
</style>

<template>
  <article class="section section--full-width" v-if="loaded">
    <header class="section__header section__header--info">
      <h2 class="section__title">
        <router-link :to="{name:'DoctorHistory'}">
          Histórico
        </router-link>
      </h2>

      <span
        :data-tooltip="info"
        class="tooltip tooltip-top page-info"
      >
        <dr-icon
          class="v-icon"
          color="silver"
          name="info"
        />
      </span>
    </header>

    <section class="section__wrapper section__wrapper--no-border">
      <div class="section__body">
        <transition-group name="fade" mode="out-in">
          <router-view
            v-if="loaded"
            :key="'router'"
            :history.sync="history"
            @showReceipt="showReceipt = $event"
          />

          <dr-loader
            v-if="loaded && loading"
            :key="'dr-loader'"
            size="lg"
            class="loader flex-center"
          />
        </transition-group>

        <h2 v-if="history.length === 0" class="text-center">
          Não há dados no seu histórico.
        </h2>
      </div>
    </section>

    <footer class="section__footer">
      <div class="see-more">
        <button
          v-if="(page < pages && ($route.name === 'DoctorHistoryList')) && history.length > 0 && !showReceipt"
          :disabled="loading || page === pages"
          @click="fetchHistory()"
          class="see-more__button"
        >
          <i v-if="loading" class="form-icon loading" />
          <span v-else>
            Ver mais
            <i class="icon icon-caret" />
          </span>
        </button>
      </div>
    </footer>
  </article>
</template>

<script>
export default {
  name: 'DrHistory',

  data () {
    return {
      loaded: false,
      loading: false,
      showReceipt: false,
      pages: null,
      page: 0,
      history: [],
      info: `Nesta página você encontra o histórico\nde atividades de todos as seus consultórios.`
    }
  },

  mounted () {
    this.fetchHistory()
  },

  watch: {
    '$route.name': function (next, prev) {
      this.fn_HIDE_PROGRESS()
    }
  },

  methods: {
    fetchHistory () {
      if (this.page === 0) {
        this.loading = true
        this.loaded = false
        this.history = []
      }

      const url = `/${
        this.fn_IS_DOCTOR() ? 'doctor' : `secretary/doctor/${this.$route.params.doctorId}`
      }/history?page=${
        this.page + 1
      }&itensPerPage=10&order[t.date]=DESC`

      this.loading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.history = res.data.data
          this.pages = res.data.pagination.totalPages
          this.page = res.data.pagination.currentPage
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.loading = false
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>
